

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface AccreditationParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Accreditation {
  id?: number;
  name: string;
  
  parameters?: AccreditationParameter[];
  links?: any;
}

export abstract class AccreditationData {
 
  abstract list(): Observable<Accreditation[]>;
  abstract create(url: string,data: Accreditation): Observable<any>;
  abstract update(url: string,data: Accreditation): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
